<template>
  <el-select
    v-model="school_id"
    class="schoolSelect"
    :placeholder="placeholder"
    filterable
    remote
    clearable
    :remote-method="searchSchools"
    :loading="loading"
    @clear="$emit('input', null)"
  >
    <el-option
      v-for="school in schools"
      :key="school.id"
      :label="school.title"
      :value="school.id"
    >
      {{ school.title }}
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "SchoolSelect",
  props: {
    value: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      required: true,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    schools: []
  }),
  computed: {
    school_id: {
      get() {
        return this.value !== 0 ? this.value : null
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    title: {
      immediate: true,
      async handler(newVal) {
        if (newVal) {
          this.schools = await this.$api.forms.getSchools({ search: newVal })
        }
      }
    }
  },
  methods: {
    async searchSchools(query) {
      if (query !== '') {
        this.loading = true
        this.schools = await this.$api.forms.getSchools({ search: query })
        this.loading = false
      } else {
        this.options = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.schoolSelect';

#{$c} {
}
</style>